import { useExperimentVariation } from '@do/seashell/hooks';
import { getCookieValue, setCookieValue } from '@do/seashell/utils';
import React, { useEffect } from 'react';
import {
  NEW_BRAND_DESIGN_EXPERIMENT,
  NEW_BRAND_DESIGN_EXPERIMENT_COOKIE
} from '../constants';

export enum NewBrandDesignVariations {
  CONTROL = 'control',
  TREATMENT = 'treatment'
}

const LoadNewBrandDesignExperiment: React.FC<{
  setIsNewBrandDesignEnabled: (isNewBrandDesignEnabled: boolean) => void;
}> = ({ setIsNewBrandDesignEnabled }) => {
  const { variation, loading: isLoading } = useExperimentVariation(
    NEW_BRAND_DESIGN_EXPERIMENT
  );
  useEffect(() => {
    if (!isLoading) {
      if (variation) {
        setCookieValue(NEW_BRAND_DESIGN_EXPERIMENT_COOKIE, variation);
        setIsNewBrandDesignEnabled(
          variation === NewBrandDesignVariations.TREATMENT
        );
      } else {
        setIsNewBrandDesignEnabled(
          getCookieValue(NEW_BRAND_DESIGN_EXPERIMENT_COOKIE) ===
            NewBrandDesignVariations.TREATMENT
        );
      }
    }
  }, [isLoading, setIsNewBrandDesignEnabled, variation]);
  return null;
};

export default LoadNewBrandDesignExperiment;
